module.exports = __webpack_public_path__ + "img/xiaochengxu-guanbi.390eed28.svg";